import classNames from 'classnames';
import { useRef } from 'react';

import Input from '../Input';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../Button';

import './CouponCodeInput.scss';

let nextCouponCodeFieldId = 0;

const CouponCodeInput = ({
  title = 'Coupon Code',
  placeholder = 'Enter code',
  value,
  onChange,
  onApply,
  disabled = false,
  applyDisabled = false,
  successMessage,
  errorMessage,
  containerClassName,
  inputContainerClassName,
  buttonClassName,
  buttonSize = BUTTON_SIZE.LARGE,
  buttonType = BUTTON_TYPE.QUATERNARY,
  applyButtonText = 'Apply Code',
  isCompact = false,
  designSystem = false,
}) => {
  const inputIdRef = useRef(null);
  if (inputIdRef.current === null) {
    inputIdRef.current = `trashie-coupon-code-${nextCouponCodeFieldId++}`;
  }
  const inputId = inputIdRef.current;
  const hasError = Boolean(errorMessage && !successMessage);
  const showLegacyFooterMessages = !designSystem;

  return (
    <div className={classNames('CouponCodeInput', containerClassName, { 'is-compact': isCompact, 'CouponCodeInput--ds20': designSystem })}>
      {!designSystem && !isCompact && (
        <div className="CouponCodeInput__title">
          {title}
        </div>
      )}
      <div className="CouponCodeInput__code">
        {designSystem ? (
          <div className="CouponCodeInput__dsFieldWrap">
            <div
              className={classNames('CouponCodeInput__dsBlock', {
                'CouponCodeInput__dsBlock--error': hasError,
              })}
            >
              <div className="CouponCodeInput__dsNotch">
                <label htmlFor={inputId} className="CouponCodeInput__dsLabel">
                  {title}
                </label>
              </div>
              <div
                className={classNames('CouponCodeInput__dsControl', {
                  'CouponCodeInput__dsControl--error': hasError,
                })}
              >
                <input
                  id={inputId}
                  type="text"
                  className="CouponCodeInput__dsInput"
                  placeholder={placeholder}
                  value={value}
                  disabled={disabled}
                  onChange={(e) => onChange(e.target.value)}
                  autoComplete="off"
                  autoCapitalize="off"
                  spellCheck={false}
                />
              </div>
            </div>
            {hasError && (
              <p className="CouponCodeInput__dsHelper CouponCodeInput__dsHelper--error">
                {errorMessage}
              </p>
            )}
            {Boolean(successMessage && !errorMessage) && (
              <p className="CouponCodeInput__dsHelper CouponCodeInput__dsHelper--success">
                {successMessage}
              </p>
            )}
          </div>
        ) : (
          <Input
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            variant="default"
            containerClassName={classNames('CouponCodeInput__input', inputContainerClassName)}
            className="CouponCodeInput__input-item"
          />
        )}
        <Button
          type={buttonType}
          size={buttonSize}
          onClick={onApply}
          disabled={applyDisabled || disabled}
          className={classNames(buttonClassName, {
            'ds20Btn ds20Btn--primary': designSystem,
          })}
        >
          {applyButtonText}
        </Button>
      </div>
      {showLegacyFooterMessages && successMessage && !errorMessage && (
        <div className="CouponCodeInput__code-successMessage">
          {successMessage}
        </div>
      )}
      {showLegacyFooterMessages && !successMessage && errorMessage && (
        <div className="CouponCodeInput__code-errorMessage">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default CouponCodeInput;
